import { render, staticRenderFns } from "./GetCardList.vue?vue&type=template&id=98021120&scoped=true&"
import script from "./GetCardList.vue?vue&type=script&lang=js&"
export * from "./GetCardList.vue?vue&type=script&lang=js&"
import style0 from "./GetCardList.vue?vue&type=style&index=0&id=98021120&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98021120",
  null
  
)

export default component.exports